import httpClient from "./httpClient";

const base = "/institute-bills";

export function generateInstituteBill(payload) {
  return httpClient.post(`${base}/generate`, payload).then((res) => res.data);
}
export function listBillableInstitutes(academicYear) {
  return httpClient.get(`${base}/institutes`, { params: { academicYear } }).then((res) => res.data.data);
}
export function listBillsForInstitute(instituteId, year) {
  return httpClient.get(base, { params: { instituteId, year } }).then((res) => res.data.data);
}
export function getBillById(instituteId, instituteBillId) {
  return httpClient.get(`${base}/${instituteBillId}`, { params: { instituteId } }).then((res) => res.data.data);
}
export function listAllBills(academicYear, paymentStatus) {
  return httpClient.get(`${base}/all`, { params: { academicYear, paymentStatus } }).then((res) => res.data.data);
}
export function listUnpaidBills(year) {
  return httpClient.get(`${base}/unpaid`, { params: { year } }).then((res) => res.data.data);
}
export function discountBill(payload) {
  return httpClient.put(`${base}/discount`, payload).then((res) => res.data);
}
export function collectBill(payload) {
  return httpClient.put(`${base}/collect`, payload).then((res) => res.data);
}
export function deleteInstituteBill(instituteId, instituteBillId) {
  return httpClient.delete(base, { params: { instituteId, instituteBillId } }).then((res) => res.data);
}
export function extendAccessExpiry(payload) {
  return httpClient.put(`${base}/access-expiry`, payload).then((res) => res.data);
}
